import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowDown, faArrowUp } from '@fortawesome/pro-light-svg-icons';
import { withTranslation } from 'react-i18next';
import { HeaderContainer, headerColumns } from './tableHeader.service';

import RQCalendarStyle from '../../../common/styles/RQCalendar.module.css';

const {
    Name, Warning, Description, RequestType, ApprovalProcess, SubmissionPeriod,
    RequestPeriod, CreatedBy, People, pointer, Setup,
} = headerColumns;

const SettingHeader = ({
    t, sortBy, sortBySelected, sortOrder,
}) => {
    const icon = sortOrder === 'Ascending' ? faArrowUp : faArrowDown;
    const sortingClass = sortOrder === 'Ascending' ? 'arrow-Ascending' : 'arrow-Descending';

    return (
        <HeaderContainer>
            <Name>
                <div style={pointer} onClick={() => { sortBy('name') }}>
                    {t('settings.name')}
                    {sortBySelected === 'name' ? <FontAwesomeIcon className={sortingClass} icon={icon} /> : <></>}
                </div>
            </Name>
            <Warning>
                <div style={pointer} onClick={() => { sortBy('warnings') }}>
                    {t('settings.warning')}
                    {sortBySelected === 'warnings' ? <FontAwesomeIcon className={sortingClass} icon={icon} /> : <></>}
                </div>
            </Warning>
            <Description>
                <div style={pointer} onClick={() => { sortBy('description') }}>
                    {t('settings.description')}
                    {sortBySelected === 'description' ? <FontAwesomeIcon className={sortingClass} icon={icon} /> : <></>}
                </div>
            </Description>
            <RequestType>
                <div style={pointer} onClick={() => { sortBy('requestTypeLabel') }}>
                    {t('settings.requestType')}
                    {sortBySelected === 'requestTypeLabel' ? <FontAwesomeIcon className={sortingClass} icon={icon} /> : <></>}
                </div>
            </RequestType>
            <ApprovalProcess>
                <div style={pointer} onClick={() => { sortBy('approvalProcessLabel') }}>
                    {t('settings.apprProcess')}
                    {sortBySelected === 'approvalProcessLabel' ? <FontAwesomeIcon className={sortingClass} icon={icon} /> : <></>}
                </div>
            </ApprovalProcess>
            <SubmissionPeriod>
                <div style={pointer} onClick={() => { sortBy('submissionPeriodLabel') }}>
                    {t('settings.submissionPeriodDateTime')}
                    {sortBySelected === 'submissionPeriodLabel' ? <FontAwesomeIcon className={sortingClass} icon={icon} /> : <></>}
                </div>
            </SubmissionPeriod>
            <RequestPeriod>
                <div style={pointer} onClick={() => { sortBy('requestPeriodLabel') }}>
                    {t('settings.requestPeriodDateTime')}
                    {sortBySelected === 'requestPeriodLabel' ? <FontAwesomeIcon className={sortingClass} icon={icon} /> : <></>}
                </div>
            </RequestPeriod>
            <CreatedBy>
                <div style={pointer} onClick={() => { sortBy('createdByName') }}>
                    {t('settings.createdBy')}
                    {sortBySelected === 'createdByName' ? <FontAwesomeIcon className={sortingClass} icon={icon} /> : <></>}
                </div>
            </CreatedBy>
            <People>
                {t('settings.people')}
            </People>
            <Setup>
                {t('settings.setup')}
            </Setup>
        </HeaderContainer>
    )
}

export default withTranslation('employmentBillboard')(SettingHeader);